export const userContactBookmarkConstants = {
  FETCH_USER_CONTACT_ACTION_REQUEST: 'FETCH_USER_CONTACT_ACTION_REQUEST',
  FETCH_USER_CONTACT_ACTION_SUCCESS: 'FETCH_USER_CONTACT_ACTION_SUCCESS',
  FETCH_USER_CONTACT_ACTION_FAILURE: 'FETCH_USER_CONTACT_ACTION_FAILURE',

  FETCH_USER_CONTACT_DETAILS_ACTION_REQUEST: 'FETCH_USER_CONTACT_DETAILS_ACTION_REQUEST',
  FETCH_USER_CONTACT_DETAILS_ACTION_SUCCESS: 'FETCH_USER_CONTACT_DETAILS_ACTION_SUCCESS',
  FETCH_USER_CONTACT_DETAILS_ACTION_FAILURE: 'FETCH_USER_CONTACT_DETAILS_ACTION_FAILURE',

  // constants for creating contacts
  CREATE_USER_CONTACT_ACTION_REQUEST: 'UPDATE_USER_CONTACT_ACTION_REQUEST',
  CREATE_USER_CONTACT_ACTION_SUCCESS: 'UPDATE_USER_CONTACT_ACTION_SUCCESS',
  CREATE_USER_CONTACT_ACTION_FAILURE: 'UPDATE_USER_CONTACT_ACTION_FAILURE',

  UPDATE_USER_CONTACT_ACTION_REQUEST: 'UPDATE_USER_CONTACT_ACTION_REQUEST',
  UPDATE_USER_CONTACT_ACTION_SUCCESS: 'UPDATE_USER_CONTACT_ACTION_SUCCESS',
  UPDATE_USER_CONTACT_ACTION_FAILURE: 'UPDATE_USER_CONTACT_ACTION_FAILURE',

  DELETE_USER_CONTACT_ACTION_REQUEST: 'DELETE_USER_CONTACT_ACTION_REQUEST',
  DELETE_USER_CONTACT_ACTION_SUCCESS: 'DELETE_USER_CONTACT_ACTION_SUCCESS',
  DELETE_USER_CONTACT_ACTION_FAILURE: 'DELETE_USER_CONTACT_ACTION_FAILURE',

  FETCH_ALL_ADMIN_CONTACTS_ACTION_REQUEST: 'FETCH_ALL_ADMIN_CONTACTS_ACTION_REQUEST',
  FETCH_ALL_ADMIN_CONTACTS_ACTION_SUCCESS: 'FETCH_ALL_ADMIN_CONTACTS_ACTION_SUCCESS',
  FETCH_ALL_ADMIN_CONTACTS_ACTION_FAILURE: 'FETCH_ALL_ADMIN_CONTACTS_ACTION_FAILURE',

  EXPORT_SELECTED_USER_CONTACTS_ACTION_REQUEST: 'EXPORT_SELECTED_USER_CONTACTS_ACTION_REQUEST',
  EXPORT_SELECTED_USER_CONTACTS_ACTION_SUCCESS: 'EXPORT_SELECTED_USER_CONTACTS_ACTION_SUCCESS',
  EXPORT_SELECTED_USER_CONTACTS_ACTION_FAILURE: 'EXPORT_SELECTED_USER_CONTACTS_ACTION_FAILURE',

  EXPORT_USER_CONTACTS_ACTION_REQUEST: 'EXPORT_USER_CONTACTS_ACTION_REQUEST',
  EXPORT_USER_CONTACTS_ACTION_SUCCESS: 'EXPORT_USER_CONTACTS_ACTION_SUCCESS',
  EXPORT_USER_CONTACTS_ACTION_FAILURE: 'EXPORT_USER_CONTACTS_ACTION_FAILURE',

  EXPORT_ALL_ADMIN_CONTACTS_ACTION_REQUEST: 'EXPORT_ALL_ADMIN_CONTACTS_ACTION_REQUEST',
  EXPORT_ALL_ADMIN_CONTACTS_ACTION_SUCCESS: 'EXPORT_ALL_ADMIN_CONTACTS_ACTION_SUCCESS',
  EXPORT_ALL_ADMIN_CONTACTS_ACTION_FAILURE: 'EXPORT_ALL_ADMIN_CONTACTS_ACTION_FAILURE',
};
